<div class="wrapper-modal">
  <form [formGroup]="editUserForm" (ngSubmit)="submitEditUserForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">Izmeni korisnika</span>
    </div>
    <div class="content-modal">
      <div class="wrapper-input">
        <span class="label-input">Ime</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.first_name | formControl" [placeholder]="'Ime'">
        </div>
        <span class="error-message">{{editUserForm.controls.first_name | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Prezime</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.last_name | formControl" [placeholder]="'Prezime'">
        </div>
        <span class="error-message">{{editUserForm.controls.last_name | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">E-pošta</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.email | formControl" [placeholder]="'E-pošta'">
        </div>
        <span class="error-message">{{editUserForm.controls.email | formControlErrorMessages: 'Unesite validnu E-poštu.' : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Telefon</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.phone | formControl" [placeholder]="'Telefon'">
        </div>
        <span class="error-message">{{editUserForm.controls.phone | formControlErrorMessages: 'Unesite validan broj telefona.' : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Adresa</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.address | formControl" [placeholder]="'Adresa'">
        </div>
        <span class="error-message">{{editUserForm.controls.address | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Poštanski broj</span>
        <div class="zc-input">
          <input type="text" [formControl]="editUserForm.controls.postal_code | formControl" [placeholder]="'Poštanski broj'">
        </div>
        <span class="error-message">{{editUserForm.controls.postal_code | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <gr-dropdown-reactive-form
        [items]="cityList"
        [propIdentifier]="'id'"
        [dropdownLabel]="'Grad'"
        [placeholder]="'Grad'"
        [formControl]="editUserForm.controls.city_id | formControl"
        [formTriedToSubmit]="formTriedToSubmit"
      ></gr-dropdown-reactive-form>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>Izmeni</span></button>
    </div>
  </form>
</div>

